/**
 * mwApp.ssais module <br>
 * Work with settings
 *
 * @namespace mwApp/ssais
 */

import { SSAI_CONTENT_TYPES } from '../../app/core/constants'

/**
 * ConfigRoutes
 * Configuration module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/ssais
 * @see mwApp/ssais
 *
 * @ngdoc config
 * @name mwApp/ssais.config:ConfigRoutes
 */
/* @ngInject */

export default function ConfigRoutes ($stateProvider) {
  $stateProvider
    /**
     * abstract state for /ssais
     */
    .state('app.ssais', {
      abstract: true,
      url: '/ssais/:type',
      template: '<ui-view/>',
      resolve: {
        scope: ['$state', 'authSvc', function ($state, authSvc) {
          if (!authSvc.hasEnabledFlag('SSAI_SETTINGS_ENABLED')) {
            return $state.go('app.404')
          }
          return { featureEnabled: true }
        }],
        parameterTypes: function () {
          return {
            CLIENT: 'Client Side',
            STATIC: 'Static',
            SERVER: 'Server Side'
          }
        },
        contentTypeKey: /* @ngInject */ function ($transition$) {
          const { type } = $transition$.params()
          return type
        },
        contentType: /* @ngInject */ function (contentTypeKey) {
          return SSAI_CONTENT_TYPES[contentTypeKey].request
        },
        macrosCatalog: /* @ngInject */ function (SsaiParameter, contentType) {
          return SsaiParameter.loadMacros(contentType)
        },
        macroCategories: /* @ngInject */function ($http, contentType) {
          return $http.get(`api/mediaurls/${contentType}/macros/categories`)
            .data()
            .then(data => data.payload)
            .then(data => data.map(s => ({ key: s.id, value: s.name })))
        }
      }
    })

    /**
     * controller {@link mwApp/ssais.controller:SsaiSettingsCtrl}
     * @name /ssais
     * @memberof mwApp/ssais.config:ConfigRoutes
     */
    .state('app.ssais.list', {
      url: '',
      templateUrl: 'components/ssais/views/ssaiSettings.html',
      controller: 'SsaiSettingsCtrl as vm',
      label: 'SSAI Settings',
      access: ''
    })

  /**
   * abstract state for /ssais
   */
    .state('app.ssais.parameter', {
      abstract: true,
      url: '/:id',
      template: '<ui-view/>'
    })

  /**
   * controller {@link mwApp/addAcl.controller:AddSsaiParameterCtrl}
   * @name /:type/:id
   * @memberof mwApp/acls.config:ConfigRoutes
   */
    .state('app.ssais.parameter.edit', {
      url: '',
      templateUrl: 'components/ssais/views/addParameter.html',
      controller: 'AddSsaiParameterCtrl as vm',
      label: '{{::id | addOrEdit}} Parameter',
      resolve: {
        parameter: /* @ngInject */ function ($transition$, SsaiParameter, contentType) {
          const { id } = $transition$.params()
          return +id
            ? SsaiParameter.load({ id, contentType })
            : new SsaiParameter({ contentType })
        }
      }
    })
}
